import React from 'react';
import { StoryblokComponent, storyblokEditable } from 'gatsby-source-storyblok';

const QuizQuestion = ({ blok }) => {
  return (
    <div
      className="col-span-12 grid grid-cols-subgrid gap-y-4"
      {...storyblokEditable(blok)}
    >
      <div class="col-span-12">
        <h2>{blok.title}</h2>
        <p>{blok.description}</p>
      </div>
      {blok.alternatives?.map((alt) => (
        <StoryblokComponent blok={alt} />
      ))}
    </div>
  );
};

export default QuizQuestion;
